import { useEffect, useState } from 'react';
import { useI18nStore } from '../../lib/i18n';

const PH = { tr: 'SS:DD', en: 'HH:MM', nl: 'UU:MM', fr: 'HH:MM' };

const norm = (raw) => {
  const d = raw.replace(/\D/g, '').slice(0, 4);
  return d.length > 2 ? `${d.slice(0, 2)}:${d.slice(2)}` : d;
};
export const validHHMM = (v) => /^([01]\d|2[0-3]):[0-5]\d$/.test(v);

/** 24 saat formatında (SS:DD) saat girişi — tarayıcının AM/PM gösteriminden bağımsız. */
export function Time24Input({ value, onChange, className = '', testId, placeholder }) {
  const lang = useI18nStore((st) => st.language);
  const [txt, setTxt] = useState(value || '');
  useEffect(() => { setTxt(value || ''); }, [value]);
  const bad = txt && txt.length === 5 && !validHHMM(txt);
  return (
    <input type="text" inputMode="numeric" value={txt} placeholder={placeholder || PH[lang] || 'HH:MM'} maxLength={5} data-testid={testId}
      onChange={(e) => {
        const v = norm(e.target.value);
        setTxt(v);
        if (v === '' || validHHMM(v)) onChange(v);
      }}
      onBlur={() => { if (txt && !validHHMM(txt)) setTxt(value || ''); }}
      className={`${className} tabular-nums ${bad ? 'border-rose-400 text-rose-600' : ''}`} />
  );
}
